module.exports = __webpack_public_path__ + "img/zagazighospital.baeeb859.jpg";